<template>
  <div class="p-3 pb-20 bg mb-auto h-full overflow-auto bg-gradient-to-b from-gray-800 text-white" id="style-1">
    <div v-if="toggleModal === 'StatsModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <StatsModal @cancelModal="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'AdventureModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <AdventureModal @cancelModal="toggleModal = ''" @exploreMap="handleExploreMap" />
    </div>
    <div v-if="toggleModal === 'BagModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <BagModal @closeInventory="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'EquippedItemsModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <EquippedItemsModal @closeEquippedItems="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'ChangeTraitModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <ChangeTraitModal :is-open="toggleModal === 'ChangeTraitModal'" @close="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'ChangeNameModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <ChangeNameModal :is-open="toggleModal === 'ChangeNameModal'" @close="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'ChangeImageModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <ChangeImageModal :is-open="toggleModal === 'ChangeImageModal'" @close="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'SkillChecklistModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <SkillChecklistModal :is-open="toggleModal === 'SkillChecklistModal'" @close="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'TattooModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <TattooModal :is-open="toggleModal === 'TattooModal'" @close="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'TitleModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <TitleModal :is-open="toggleModal === 'TitleModal'" @close="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'MapsModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <MapsModal :is-open="toggleModal === 'MapsModal'" @close="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'StatDetailsModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <StatDetailsModal :stat-name="selectedStat" :breakdown="statBreakdown" @close="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'MoveRoomModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <MoveRoomModal :is-open="toggleModal === 'MoveRoomModal'" @close="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'PowerDetailsModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <PowerDetailsModal :power-name="selectedPower" :breakdown="powerBreakdown" @close="toggleModal = ''" />
    </div>
    <div v-if="toggleModal === 'InsuranceModal'" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-70" @click="toggleModal = ''"></div>
      <InsuranceModal :is-open="toggleModal === 'InsuranceModal'" @close="toggleModal = ''" />
    </div>
    <div v-if="isLoadingAuth" class="flex items-center justify-center h-screen">
      <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-indigo-600"></div>
    </div>
    <div v-else-if="!user" class="text-center text-red-300">
      <p>คุณยังไม่ได้ล็อกอิน กรุณา <router-link to="/login" class="text-indigo-400 hover:underline">ล็อกอิน</router-link></p>
    </div>
    <div v-else-if="loading" class="flex items-center justify-center h-screen">
      <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-indigo-600"></div>
    </div>
    <div v-else-if="error" class="text-center text-red-300">
      <p>{{ error }}</p>
    </div>
    <div v-else-if="characterData && characterPrivateData" class="space-y-4">
      <div class="bg-gray-900 bg-opacity-80 border border-gray-800 p-5 rounded-lg shadow-xl">
        <div class="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
          <div class="md:col-span-3 flex justify-center">
            <div class="relative">
              <img :src="characterData.imageUrl || 'https://via.placeholder.com/112'" class="w-28 h-28 object-cover rounded-md border-2 border-gray-600 transition-all duration-200 hover:border-indigo-400" />
              <div class="absolute -bottom-2 -right-2 bg-indigo-600 text-white text-sm font-semibold px-2 py-1 rounded-full">Lv. {{ characterData.level || 1 }}</div>
            </div>
          </div>
          <div class="md:col-span-6 text-center md:text-left">
            <div class="flex items-center justify-center md:justify-start mb-2">
              <h1 class="text-xl font-semibold text-indigo-300">{{ characterData.characterName || 'Unknown' }}</h1>
            </div>
            <div class="flex items-center space-x-2 w-full">
              <div class="flex-1">
                <div v-if="characterData.level < 30" class="mt-2 flex justify-center md:justify-start items-center space-x-3 text-sm text-indigo-200">
                  <i class="fas fa-star text-indigo-400 text-sm"></i>
                  <span>ค่าประสบการณ์ ({{ characterPrivateData.experience || 0 }} / {{ nextLevelExp }})</span>
                </div>
                <div v-if="characterData.level < 30" class="w-full bg-gray-600 rounded-full h-2 mt-1">
                  <div class="bg-indigo-600 h-2 rounded-full" :style="{ width: `${experiencePercentage}%` }"></div>
                </div>
                <div v-else class="mt-2 flex justify-center md:justify-start items-center space-x-3 text-sm text-indigo-200">
                  <i class="fas fa-star text-indigo-400 text-sm"></i>
                  <span>เลเวลเต็มแล้ว</span>
                </div>
              </div>
            </div>
          </div>
          <div class="md:col-span-3 flex justify-center md:justify-end">
            <div class="flex items-center bg-gray-700 border border-gray-600 px-3 py-1 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400">
              <i class="fa-solid fa-trophy text-yellow-400 mr-2 text-sm"></i>
              <span class="text-sm font-semibold text-indigo-200">{{ characterData.renown || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-3 sm:grid-cols-6 gap-3">
        <button v-if="characterData.level <= 29" class="bg-gray-900 bg-opacity-80 hover:bg-gray-800 text-indigo-200 py-2 px-3 rounded-md transition-all duration-200 flex flex-col sm:flex-row justify-center items-center border border-gray-800" @click="toggleModal = 'MoveRoomModal'">
          <i class="fas fa-person-booth mb-1 sm:mb-0 sm:mr-2 text-sm"></i>
          <span class="text-sm">เปลี่ยนห้อง</span>
        </button>
        <button v-if="characterData.level >= 30" class="bg-gray-900 bg-opacity-80 hover:bg-gray-800 text-indigo-200 py-2 px-3 rounded-md transition-all duration-200 flex flex-col sm:flex-row justify-center items-center border border-gray-800" @click="toggleModal = 'StatsModal'">
          <i class="fas fa-chart-bar mb-1 sm:mb-0 sm:mr-2 text-sm"></i>
          <span class="text-sm">สเตตัส</span>
        </button>
        <button class="bg-gray-900 bg-opacity-80 hover:bg-gray-800 text-indigo-200 py-2 px-3 rounded-md transition-all duration-200 flex flex-col sm:flex-row justify-center items-center border border-gray-800" @click="toggleModal = 'SkillChecklistModal'">
          <i class="fas fa-book-open mb-1 sm:mb-0 sm:mr-2 text-sm"></i>
          <span class="text-sm">ทักษะ</span>
        </button>
        <button class="bg-gray-900 bg-opacity-80 hover:bg-gray-800 text-indigo-200 py-2 px-3 rounded-md transition-all duration-200 flex flex-col sm:flex-row justify-center items-center border border-gray-800" @click="toggleModal = 'TattooModal'">
          <i class="fas fa-paint-brush mb-1 sm:mb-0 sm:mr-2 text-sm"></i>
          <span class="text-sm">รอยสัก</span>
        </button>
        <button class="bg-gray-900 bg-opacity-80 hover:bg-gray-800 text-indigo-200 py-2 px-3 rounded-md transition-all duration-200 flex flex-col sm:flex-row justify-center items-center border border-gray-800" @click="toggleModal = 'TitleModal'">
          <i class="fas fa-crown mb-1 sm:mb-0 sm:mr-2 text-sm"></i>
          <span class="text-sm">ฉายา</span>
        </button>
        <button class="bg-gray-900 bg-opacity-80 hover:bg-gray-800 text-indigo-200 py-2 px-3 rounded-md transition-all duration-200 flex flex-col sm:flex-row justify-center items-center border border-gray-800" @click="toggleModal = 'ChangeTraitModal'">
          <i class="fas fa-user mb-1 sm:mb-0 sm:mr-2 text-sm"></i>
          <span class="text-sm">ลักษณะนิสัย</span>
        </button>
        <button class="bg-gray-900 bg-opacity-80 hover:bg-gray-800 text-indigo-200 py-2 px-3 rounded-md transition-all duration-200 flex flex-col sm:flex-row justify-center items-center border border-gray-800" @click="openMapsModal">
          <i class="fas fa-map mb-1 sm:mb-0 sm:mr-2 text-sm"></i>
          <span class="text-sm">แผนที่</span>
        </button>
        <button class="bg-gray-900 bg-opacity-80 hover:bg-gray-800 text-indigo-200 py-2 px-3 rounded-md transition-all duration-200 flex flex-col sm:flex-row justify-center items-center border border-gray-800" @click="toggleModal = 'ChangeNameModal'">
          <i class="fas fa-edit mb-1 sm:mb-0 sm:mr-2 text-sm"></i>
          <span class="text-sm">เปลี่ยนชื่อ</span>
        </button>
        <button class="bg-gray-900 bg-opacity-80 hover:bg-gray-800 text-indigo-200 py-2 px-3 rounded-md transition-all duration-200 flex flex-col sm:flex-row justify-center items-center border border-gray-800" @click="toggleModal = 'ChangeImageModal'">
          <i class="fas fa-person mb-1 sm:mb-0 sm:mr-2 text-sm"></i>
          <span class="text-sm">เปลี่ยนสกิน</span>
        </button>
        <button class="bg-gray-900 bg-opacity-80 hover:bg-gray-800 text-indigo-200 py-2 px-3 rounded-md transition-all duration-200 flex flex-col sm:flex-row justify-center items-center border border-gray-800" @click="toggleModal = 'InsuranceModal'">
          <i class="fas fa-shield-alt mb-1 sm:mb-0 sm:mr-2 text-sm"></i>
          <span class="text-sm">ประกัน</span>
        </button>
      </div>
      <div v-if="isAdmin && itemMechMismatch" class="text-center text-red-300 bg-gray-800 bg-opacity-70 p-2 rounded-md border border-red-500 animate-pulse">
        <p>Item References และ Mechanical Item IDs ไม่ตรง (มีไอดีซ้ำ)</p>
      </div>
      <div v-if="isAdmin && !isAllStatsMatching" class="text-center text-red-300 bg-gray-800 bg-opacity-70 p-2 rounded-md border border-red-500 animate-pulse">
        <p>ไม่ตรง (กำลังซิงค์อัตโนมัติ...)</p>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="bg-gray-900 bg-opacity-80 border border-gray-800 p-5 rounded-lg shadow-xl">
          <h3 class="text-xl font-semibold text-indigo-300 mb-3">ค่าสเตตัส</h3>
          <div class="grid grid-cols-2 gap-3">
            <div class="text-center p-2 bg-gray-800 bg-opacity-80 border border-gray-700 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400 cursor-pointer" @click="showStatDetails('stamina')">
              <i class="fas fa-heart text-indigo-400 text-lg mb-1"></i>
              <div class="text-lg font-semibold text-white">{{ totalStats.stamina }}</div>
              <div class="text-xs text-indigo-200">STAMINA</div>
            </div>
            <div class="text-center p-2 bg-gray-800 bg-opacity-80 border border-gray-700 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400 cursor-pointer" @click="showStatDetails('str')">
              <i class="fas fa-dumbbell text-indigo-400 text-lg mb-1"></i>
              <div class="text-lg font-semibold text-white">{{ totalStats.str }}</div>
              <div class="text-xs text-indigo-200">STR</div>
            </div>
            <div class="text-center p-2 bg-gray-800 bg-opacity-80 border border-gray-700 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400 cursor-pointer" @click="showStatDetails('int')">
              <i class="fas fa-brain text-indigo-400 text-lg mb-1"></i>
              <div class="text-lg font-semibold text-white">{{ totalStats.int }}</div>
              <div class="text-xs text-indigo-200">INT</div>
            </div>
            <div class="text-center p-2 bg-gray-800 bg-opacity-80 border border-gray-700 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400 cursor-pointer" @click="showStatDetails('agi')">
              <i class="fas fa-running text-indigo-400 text-lg mb-1"></i>
              <div class="text-lg font-semibold text-white">{{ totalStats.agi }}</div>
              <div class="text-xs text-indigo-200">AGI</div>
            </div>
            <div class="text-center p-2 bg-gray-800 bg-opacity-80 border border-gray-700 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400 cursor-pointer" @click="showStatDetails('luck')">
              <i class="fas fa-clover text-indigo-400 text-lg mb-1"></i>
              <div class="text-lg font-semibold text-white">{{ totalStats.luck }}</div>
              <div class="text-xs text-indigo-200">LUCK</div>
            </div>
          </div>
        </div>
        <div class="bg-gray-900 bg-opacity-80 border border-gray-800 p-5 rounded-lg shadow-xl">
          <h3 class="text-xl font-semibold text-indigo-300 mb-3">ค่าพลัง</h3>
          <div class="space-y-2">
            <div
              class="flex justify-between items-center py-1 border-b border-gray-800 cursor-pointer transition-all duration-200 hover:bg-gray-700"
              @click="showPowerDetails('maxHp')"
            >
              <span class="text-sm text-indigo-200 flex items-center">
                <i class="fas fa-heartbeat text-indigo-400 mr-2 text-sm"></i> พลังชีวิตสูงสุด
              </span>
              <span class="text-sm font-semibold text-white">{{ calculatedStats.maxHp }}</span>
            </div>
            <div
              class="flex justify-between items-center py-1 border-b border-gray-800 cursor-pointer transition-all duration-200 hover:bg-gray-700"
              @click="showPowerDetails('atk')"
            >
              <span class="text-sm text-indigo-200 flex items-center">
                <i class="fas fa-fist-raised text-indigo-400 mr-2 text-sm"></i> พลังโจมตี
              </span>
              <span class="text-sm font-semibold text-white">{{ calculatedStats.atk }}</span>
            </div>
            <div
              class="flex justify-between items-center py-1 border-b border-gray-800 cursor-pointer transition-all duration-200 hover:bg-gray-700"
              @click="showPowerDetails('critical')"
            >
              <span class="text-sm text-indigo-200 flex items-center">
                <i class="fas fa-crosshairs text-indigo-400 mr-2 text-sm"></i> คริติคอล
              </span>
              <span class="text-sm font-semibold text-white">{{ calculatedStats.critical }}%</span>
            </div>
            <div
              class="flex justify-between items-center py-1 border-b border-gray-800 cursor-pointer transition-all duration-200 hover:bg-gray-700"
              @click="showPowerDetails('evasion')"
            >
              <span class="text-sm text-indigo-200 flex items-center">
                <i class="fas fa-running text-indigo-400 mr-2 text-sm"></i> หลบหลีก
              </span>
              <span class="text-sm font-semibold text-white">{{ calculatedStats.evasion }}%</span>
            </div>
            <div
              class="flex justify-between items-center py-1 border-b border-gray-800 cursor-pointer transition-all duration-200 hover:bg-gray-700"
              @click="showPowerDetails('criticalReduction')"
            >
              <span class="text-sm text-indigo-200 flex items-center">
                <i class="fas fa-shield-virus text-indigo-400 mr-2 text-sm"></i> ลดคริติคอล
              </span>
              <span class="text-sm font-semibold text-white">{{ calculatedStats.criticalReduction }}%</span>
            </div>
            <div
              class="flex justify-between items-center py-1 border-b border-gray-800 cursor-pointer transition-all duration-200 hover:bg-gray-700"
              @click="showPowerDetails('dropRateBonus')"
            >
              <span class="text-sm text-indigo-200 flex items-center">
                <i class="fas fa-gift text-indigo-400 mr-2 text-sm"></i> โบนัสดรอป
              </span>
              <span class="text-sm font-semibold text-white">{{ calculatedStats.dropRateBonus }}%</span>
            </div>
            <div
              class="flex justify-between items-center py-1 border-b border-gray-800 cursor-pointer transition-all duration-200 hover:bg-gray-700"
              @click="showPowerDetails('damageReduction')"
            >
              <span class="text-sm text-indigo-200 flex items-center">
                <i class="fa-solid fa-person-rays text-indigo-400 mr-2 text-sm"></i> ลดดาเมจ
              </span>
              <span class="text-sm font-semibold text-white">{{ calculatedStats.damageReduction }}%</span>
            </div>
            <div
              class="flex justify-between items-center py-1 cursor-pointer transition-all duration-200 hover:bg-gray-700"
              @click="showPowerDetails('defense')"
            >
              <span class="text-sm text-indigo-200 flex items-center">
                <i class="fas fa-shield-alt text-indigo-400 mr-2 text-sm"></i> พลังป้องกัน
              </span>
              <span class="text-sm font-semibold text-white">{{ calculatedStats.defense }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-4">
        <button @click="goToMenu" class="bg-indigo-600 hover:bg-indigo-700 w-full text-white text-sm font-semibold py-2 px-4 rounded-md transition-all duration-200">
          <i class="fas fa-arrow-left mr-2 text-xs"></i> กลับไปเมนู
        </button>
      </div>
    </div>
    <div v-else class="text-center text-indigo-200 py-6">
      <p>ไม่พบข้อมูลตัวละคร</p>
    </div>
  </div>
</template>
<script>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { projectFirestore, projectFunctions } from '@/firebase/config';
import gameItemsData from '@/data/gameItems.json';
import getUser from '@/composables/getUser';
import { usePlayerStore } from '@/composables/usePlayerStore';
import StatsModal from '../components/character/StatsModal.vue';
import AdventureModal from '../components/character/AdventureModal.vue';
import BagModal from '../components/character/BagModal.vue';
import EquippedItemsModal from '@/components/character/EquippedItemsModal.vue';
import ChangeTraitModal from '@/components/character/ChangeTraitModal.vue';
import ChangeNameModal from '@/components/character/ChangeNameModal.vue';
import ChangeImageModal from '@/components/character/ChangeImageModal.vue';
import SkillChecklistModal from '@/components/character/SkillChecklistModal.vue';
import TattooModal from '@/components/character/TattooModal.vue';
import TitleModal from '../components/character/TitleModal.vue';
import MapsModal from '../components/character/MapModal.vue';
import StatDetailsModal from '../components/character/StatDetailsModal.vue';
import MoveRoomModal from '@/components/character/MoveRoomModal.vue';
import PowerDetailsModal from '../components/character/PowerDetailsModal.vue';
import InsuranceModal from '@/components/character/InsuranceModal.vue';
import BottomMenu from '@/components/BottomMenu.vue';

const STAT_KEYS = ['stamina', 'str', 'int', 'agi', 'luck', 'maxHp', 'atk', 'evasion', 'critical', 'defense'];
const LEVEL_EXP_TABLE = [
  { level: 1, expRequired: 50 },
  { level: 2, expRequired: 100 },
  { level: 3, expRequired: 150 },
  { level: 4, expRequired: 200 },
  { level: 5, expRequired: 250 },
  { level: 6, expRequired: 300 },
  { level: 7, expRequired: 350 },
  { level: 8, expRequired: 400 },
  { level: 9, expRequired: 450 },
  { level: 10, expRequired: 500 },
  { level: 11, expRequired: 600 },
  { level: 12, expRequired: 700 },
  { level: 13, expRequired: 800 },
  { level: 14, expRequired: 900 },
  { level: 15, expRequired: 1000 },
  { level: 16, expRequired: 1150 },
  { level: 17, expRequired: 1300 },
  { level: 18, expRequired: 1450 },
  { level: 19, expRequired: 1600 },
  { level: 20, expRequired: 1750 },
  { level: 21, expRequired: 1950 },
  { level: 22, expRequired: 2150 },
  { level: 23, expRequired: 2350 },
  { level: 24, expRequired: 2550 },
  { level: 25, expRequired: 2750 },
  { level: 26, expRequired: 3050 },
  { level: 27, expRequired: 3350 },
  { level: 28, expRequired: 3650 },
  { level: 29, expRequired: 3950 },
];
LEVEL_EXP_TABLE.forEach((levelData, index) => {
  levelData.totalExp = index === 0 ? 0 : LEVEL_EXP_TABLE[index - 1].totalExp + LEVEL_EXP_TABLE[index - 1].expRequired;
});

const emptyStats = () => STAT_KEYS.reduce((acc, stat) => {
  acc[stat] = 0;
  return acc;
}, {});

const areStatsEqual = (left = {}, right = {}) => STAT_KEYS.every((stat) => (left?.[stat] || 0) === (right?.[stat] || 0));

const findGameItemData = (idOrName) => {
  if (!idOrName) return null;
  if (gameItemsData[idOrName]) {
    return { id: idOrName, ...gameItemsData[idOrName] };
  }
  const entries = Array.isArray(gameItemsData)
    ? gameItemsData.map((item, index) => [item.id || item.itemId || String(index), item])
    : Object.entries(gameItemsData);
  const found = entries.find(([id, item]) => (
    id === idOrName || item?.id === idOrName || item?.itemId === idOrName || item?.name === idOrName
  ));
  return found ? { id: found[0], ...found[1] } : null;
};

export default {
  name: 'Character',
  components: {
    StatsModal,
    AdventureModal,
    BagModal,
    EquippedItemsModal,
    ChangeTraitModal,
    ChangeNameModal,
    ChangeImageModal,
    SkillChecklistModal,
    TattooModal,
    TitleModal,
    MapsModal,
    StatDetailsModal,
    MoveRoomModal,
    PowerDetailsModal,
    InsuranceModal,
    BottomMenu
  },
  setup() {
    const router = useRouter();
    const { user, isLoadingAuth } = getUser();
    const characterData = ref(null);
    const characterPrivateData = ref(null);
    const equippedItems = ref(null);
    const items = ref([]);
    const mechanicalItems = ref([]);
    const ghostItems = ref({});
    const loading = ref(true);
    const error = ref(null);
    const toggleModal = ref('');
    const selectedStat = ref(null);
    const selectedPower = ref(null);
    const isAdmin = ref(false);
    const syncing = ref(false);

    const totalStats = computed(() => {
      if (!characterPrivateData.value) {
        return {
          str: 0,
          stamina: 0,
          int: 0,
          agi: 0,
          luck: 0,
          maxHp: 0,
          atk: 0,
          evasion: 0,
          critical: 0,
          defense: 0
        };
      }
      const stats = characterPrivateData.value;
      const ghostStats = stats.ghostStats || { str: 0, stamina: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0 };
      return {
        str: (stats.itemStats?.str || 0) + (stats.bonusStats?.str || 0) + (stats.stats?.str || 0) + (stats.traitStats?.str || 0) + (stats.skillStats?.str || 0) + (stats.titleStats?.str || 0) + (stats.tattooStats?.str || 0) + (ghostStats.str || 0),
        stamina: (stats.itemStats?.stamina || 0) + (stats.bonusStats?.stamina || 0) + (stats.stats?.stamina || 0) + (stats.traitStats?.stamina || 0) + (stats.skillStats?.stamina || 0) + (stats.titleStats?.stamina || 0) + (stats.tattooStats?.stamina || 0) + (ghostStats.stamina || 0),
        int: (stats.itemStats?.int || 0) + (stats.bonusStats?.int || 0) + (stats.stats?.int || 0) + (stats.traitStats?.int || 0) + (stats.skillStats?.int || 0) + (stats.titleStats?.int || 0) + (stats.tattooStats?.int || 0) + (ghostStats.int || 0),
        agi: (stats.itemStats?.agi || 0) + (stats.bonusStats?.agi || 0) + (stats.stats?.agi || 0) + (stats.traitStats?.agi || 0) + (stats.skillStats?.agi || 0) + (stats.titleStats?.agi || 0) + (stats.tattooStats?.agi || 0) + (ghostStats.agi || 0),
        luck: (stats.itemStats?.luck || 0) + (stats.bonusStats?.luck || 0) + (stats.stats?.luck || 0) + (stats.traitStats?.luck || 0) + (stats.skillStats?.luck || 0) + (stats.titleStats?.luck || 0) + (stats.tattooStats?.luck || 0) + (ghostStats.luck || 0),
        maxHp: (stats.itemStats?.maxHp || 0) + (stats.bonusStats?.maxHp || 0) + (stats.stats?.maxHp || 0) + (stats.traitStats?.maxHp || 0) + (stats.skillStats?.maxHp || 0) + (stats.titleStats?.maxHp || 0) + (stats.tattooStats?.maxHp || 0) + (ghostStats.maxHp || 0),
        atk: (stats.itemStats?.atk || 0) + (stats.bonusStats?.atk || 0) + (stats.stats?.atk || 0) + (stats.traitStats?.atk || 0) + (stats.skillStats?.atk || 0) + (stats.titleStats?.atk || 0) + (stats.tattooStats?.atk || 0) + (ghostStats.atk || 0),
        evasion: (stats.itemStats?.evasion || 0) + (stats.bonusStats?.evasion || 0) + (stats.stats?.evasion || 0) + (stats.traitStats?.evasion || 0) + (stats.skillStats?.evasion || 0) + (stats.titleStats?.evasion || 0) + (stats.tattooStats?.evasion || 0) + (ghostStats.evasion || 0),
        critical: (stats.itemStats?.critical || 0) + (stats.bonusStats?.critical || 0) + (stats.stats?.critical || 0) + (stats.traitStats?.critical || 0) + (stats.skillStats?.critical || 0) + (stats.titleStats?.critical || 0) + (stats.tattooStats?.critical || 0) + (ghostStats.critical || 0),
        defense: (stats.itemStats?.defense || 0) + (stats.bonusStats?.defense || 0) + (stats.stats?.defense || 0) + (stats.traitStats?.defense || 0) + (stats.skillStats?.defense || 0) + (stats.titleStats?.defense || 0) + (stats.tattooStats?.defense || 0) + (ghostStats.defense || 0)
      };
    });

    const calculatedStats = computed(() => {
      const stats = totalStats.value;
      const defenseBonus = Math.floor(stats.defense / 20);
      return {
        atk: stats.str * 2 + stats.atk,
        critical: Number((Math.floor((stats.int / 2) + stats.critical)).toFixed(2)),
        maxHp: stats.stamina * 20 + stats.maxHp,
        evasion: Number((Math.floor((stats.agi / 2) + stats.evasion)).toFixed(2)),
        defense: stats.defense,
        flee: Math.floor(((stats.agi / 2) + (stats.int / 2)) / 2),
        criticalReduction: Number((Math.floor(stats.luck) + defenseBonus).toFixed(2)),
        dropRateBonus: Number((stats.luck * 0.01).toFixed(2)),
        damageReduction: Number(defenseBonus.toFixed(2))
      };
    });

    const currentHealth = computed(() => {
      const damage = characterPrivateData.value?.damageTaken ?? 0;
      return Math.max(0, calculatedStats.value.maxHp - damage);
    });

    const nextLevelExp = computed(() => {
      if (!characterData.value) return 0;
      const currentLevel = characterData.value.level || 1;
      const levelData = LEVEL_EXP_TABLE.find(data => data.level === currentLevel);
      return levelData ? levelData.expRequired : 0;
    });

    const experiencePercentage = computed(() => {
      if (!characterPrivateData.value || !nextLevelExp.value) return 0;
      const currentExp = characterPrivateData.value.experience || 0;
      return Math.min(100, (currentExp / nextLevelExp.value) * 100);
    });

    const itemMechMismatch = computed(() => {
      if (!characterPrivateData.value) return false;
      const itemInstanceIds = new Set(Object.keys(characterPrivateData.value.equippedItems || {}));
      const mechInstanceIds = Object.keys(characterPrivateData.value.mechanicalItems || {});
      return mechInstanceIds.some(id => itemInstanceIds.has(id));
    });

    const calculatedItemStats = computed(() => {
      const stats = {
        stamina: 0, str: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0,
      };
      [...items.value, ...mechanicalItems.value].forEach((item) => {
        const itemStats = item.stats || {};
        const upgradeStats = item.upgradeStats || {};
        const cardStats = item.cardStats || {};
        stats.stamina += (itemStats.stamina || 0) + (upgradeStats.stamina || 0) + (cardStats.stamina || 0);
        stats.str += (itemStats.str || 0) + (upgradeStats.str || 0) + (cardStats.str || 0);
        stats.int += (itemStats.int || 0) + (upgradeStats.int || 0) + (cardStats.int || 0);
        stats.agi += (itemStats.agi || 0) + (upgradeStats.agi || 0) + (cardStats.agi || 0);
        stats.luck += (itemStats.luck || 0) + (upgradeStats.luck || 0) + (cardStats.luck || 0);
        stats.maxHp += (itemStats.maxHp || 0) + (upgradeStats.maxHp || 0) + (cardStats.maxHp || 0);
        stats.atk += (itemStats.atk || 0) + (upgradeStats.atk || 0) + (cardStats.atk || 0);
        stats.evasion += (itemStats.evasion || 0) + (upgradeStats.evasion || 0) + (cardStats.evasion || 0);
        stats.critical += (itemStats.critical || 0) + (upgradeStats.critical || 0) + (cardStats.critical || 0);
        stats.defense += (itemStats.defense || 0) + (upgradeStats.defense || 0) + (cardStats.defense || 0);
      });
      return stats;
    });

    const isItemStatsMatching = computed(() => {
      if (!characterPrivateData.value || !characterPrivateData.value.itemStats) return true;
      const itemStats = characterPrivateData.value.itemStats;
      return (
        itemStats.stamina === calculatedItemStats.value.stamina &&
        itemStats.str === calculatedItemStats.value.str &&
        itemStats.int === calculatedItemStats.value.int &&
        itemStats.agi === calculatedItemStats.value.agi &&
        itemStats.luck === calculatedItemStats.value.luck &&
        itemStats.maxHp === calculatedItemStats.value.maxHp &&
        itemStats.atk === calculatedItemStats.value.atk &&
        itemStats.evasion === calculatedItemStats.value.evasion &&
        itemStats.critical === calculatedItemStats.value.critical &&
        itemStats.defense === calculatedItemStats.value.defense
      );
    });

    const setConfigs = {
      'เซ็ตทหาร': {
        items: [
          'หมวกทหาร', 'เสื้อกองทัพบก', 'เสื้อคลุมทหาร', 'ถุงมือทหาร',
          'กางเกงทหาร', 'รองเท้าคอมแบท', 'เข็มขัดทหาร', 'แท่งเหล็กปลายมีด'
        ],
        bonuses: {
          4: { critical: 4, evasion: 4, atk: 20 },
          8: { critical: 10, evasion: 10, atk: 50 }
        }
      },
      'เซ็ตนักดับเพลิง': {
        items: [
          'หมวกนิรภัย', 'เสื้อนักดับเพลิง', 'เสื้อคลุมนักดับเพลิง', 'ถุงมือนักดับเพลิง',
          'กางเกงนักดับเพลิง', 'รองเท้านักดับเพลิง', 'เข็มขัดนักดับเพลิง', 'เลื่อยไฟฟ้า'
        ],
        bonuses: {
          4: { maxHp: 1000, critical: 4, defense: 20 },
          8: { maxHp: 2500, critical: 10, defense: 50, atk: 10 }
        }
      },
      'เซ็ตตัวตลก': {
        items: ['ถุงมือตัวตลก', 'เสื้อตัวตลก', 'กางเกงตัวตลก', 'หมวกตัวตลก', 'รองเท้าตัวตลก'],
        bonuses: {
          2: { atk: 15, critical: 10 },
          5: { atk: 40, critical: 20 }
        }
      },
      'เซ็ตเทควันโด้': {
        items: ['เสื้อเทควันโด', 'เสื้อคลุมเทควันโด', 'กางเกงเทควันโด'],
        bonuses: {
          3: { evasion: 20, atk: 30 }
        }
      },
      'เซ็นนักรบไทย': {
        items: ['เกราะนักรบไทย', 'ปลอกแขนนักรบไทย', 'สนับแข้งนักรบไทย','หมวกนักรบไทย','หมวกอัศวิน','ดาบ'],
        bonuses: {
          3: { critical: 3, evasion: 3, atk: 20},
          4: { critical: 6, evasion: 6, atk: 30},
          5: { critical: 10, evasion: 10, atk: 40}
        }
      }
    };

    const calculatedBonusStats = computed(() => {
      const stats = {
        stamina: 0, str: 0, int: 0, agi: 0, luck: 0, maxHp: 0,
        atk: 0, evasion: 0, critical: 0, defense: 0
      };
      const itemNames = items.value.map(item => item.name).filter(Boolean);
      for (const [setName, config] of Object.entries(setConfigs)) {
        const equippedInSet = itemNames.filter(name => config.items.includes(name)).length;
        if (equippedInSet === 0) continue;
        const bonusKeys = Object.keys(config.bonuses).map(Number).sort((a, b) => b - a);
        for (const required of bonusKeys) {
          if (equippedInSet >= required) {
            const bonus = config.bonuses[required];
            for (const [stat, value] of Object.entries(bonus)) {
              stats[stat] = (stats[stat] || 0) + value;
            }
            break;
          }
        }
      }
      return stats;
    });

    const isBonusStatsMatching = computed(() => {
      if (!characterPrivateData.value || !characterPrivateData.value.bonusStats) return true;
      const bonusStats = characterPrivateData.value.bonusStats;
      return (
        bonusStats.stamina === calculatedBonusStats.value.stamina &&
        bonusStats.str === calculatedBonusStats.value.str &&
        bonusStats.int === calculatedBonusStats.value.int &&
        bonusStats.agi === calculatedBonusStats.value.agi &&
        bonusStats.luck === calculatedBonusStats.value.luck &&
        bonusStats.maxHp === calculatedBonusStats.value.maxHp &&
        bonusStats.atk === calculatedBonusStats.value.atk &&
        bonusStats.evasion === calculatedBonusStats.value.evasion &&
        bonusStats.critical === calculatedBonusStats.value.critical &&
        bonusStats.defense === calculatedBonusStats.value.defense
      );
    });

    const calculatedGhostStats = computed(() => {
      const stats = {
        stamina: 0, str: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0,
      };
      ghostItems.value.forEach((item) => {
        const itemStats = item.bonusStats || item.stats || {};
        stats.stamina += itemStats.stamina || 0;
        stats.str += itemStats.str || 0;
        stats.int += itemStats.int || 0;
        stats.agi += itemStats.agi || 0;
        stats.luck += itemStats.luck || 0;
        stats.maxHp += itemStats.maxHp || 0;
        stats.atk += itemStats.atk || 0;
        stats.evasion += itemStats.evasion || 0;
        stats.critical += itemStats.critical || 0;
        stats.defense += itemStats.defense || 0;
      });
      return stats;
    });

    const isGhostStatsMatching = computed(() => {
      if (!characterPrivateData.value || !characterPrivateData.value.ghostStats) return true;
      const ghostStats = characterPrivateData.value.ghostStats;
      return areStatsEqual(ghostStats, calculatedGhostStats.value);
    });

    const calculatedSkillStats = computed(() => {
      const stats = emptyStats();
      const learnedSkills = characterPrivateData.value?.learnedSkills;
      if (!Array.isArray(learnedSkills)) return stats;

      learnedSkills
        .map((idOrName) => findGameItemData(idOrName))
        .filter((skill) => skill?.type === 'หนังสือ')
        .forEach((skill) => {
          STAT_KEYS.forEach((stat) => {
            stats[stat] += Number(skill.stats?.[stat] || 0);
          });
        });

      return stats;
    });

    const isSkillStatsMatching = computed(() => {
      if (!characterPrivateData.value || !characterPrivateData.value.skillStats) return true;
      return areStatsEqual(characterPrivateData.value.skillStats, calculatedSkillStats.value);
    });

    const isAllStatsMatching = computed(() => (
      isItemStatsMatching.value &&
      isBonusStatsMatching.value &&
      isGhostStatsMatching.value &&
      isSkillStatsMatching.value
    ));

    const showStatDetails = (stat) => {
      selectedStat.value = stat;
      toggleModal.value = 'StatDetailsModal';
    };

    const statBreakdown = computed(() => {
      if (!characterPrivateData.value || !selectedStat.value) return {};
      const stats = characterPrivateData.value;
      const stat = selectedStat.value.toLowerCase();
      const ghostStats = stats.ghostStats || {};
      return {
        item: stats.itemStats?.[stat] || 0,
        bonus: stats.bonusStats?.[stat] || 0,
        tattoo: stats.tattooStats?.[stat] || 0,
        base: stats.stats?.[stat] || 0,
        trait: stats.traitStats?.[stat] || 0,
        skill: stats.skillStats?.[stat] || 0,
        title: stats.titleStats?.[stat] || 0,
        ghost: ghostStats[stat] || 0,
        total: totalStats.value[stat]
      };
    });

    const showPowerDetails = (power) => {
      selectedPower.value = power;
      toggleModal.value = 'PowerDetailsModal';
    };

    const powerBreakdown = computed(() => {
      if (!characterPrivateData.value || !selectedPower.value) return {};
      const stats = characterPrivateData.value;
      const power = selectedPower.value;
      const sources = {
        base: stats.stats || {},
        item: stats.itemStats || {},
        bonus: stats.bonusStats || {},
        trait: stats.traitStats || {},
        skill: stats.skillStats || {},
        title: stats.titleStats || {},
        tattoo: stats.tattooStats || {},
        ghost: stats.ghostStats || {}
      };
      const breakdown = {
        base: 0,
        item: 0,
        bonus: 0,
        trait: 0,
        skill: 0,
        title: 0,
        tattoo: 0,
        ghost: 0,
        total: 0
      };
      if (power === 'maxHp') {
        const multiplier = 20;
        breakdown.base = (sources.base.stamina || 0) * multiplier + (sources.base.maxHp || 0);
        breakdown.item = (sources.item.stamina || 0) * multiplier + (sources.item.maxHp || 0);
        breakdown.bonus = (sources.bonus.stamina || 0) * multiplier + (sources.bonus.maxHp || 0);
        breakdown.trait = (sources.trait.stamina || 0) * multiplier + (sources.trait.maxHp || 0);
        breakdown.skill = (sources.skill.stamina || 0) * multiplier + (sources.skill.maxHp || 0);
        breakdown.title = (sources.title.stamina || 0) * multiplier + (sources.title.maxHp || 0);
        breakdown.tattoo = (sources.tattoo.stamina || 0) * multiplier + (sources.tattoo.maxHp || 0);
        breakdown.ghost = (sources.ghost.stamina || 0) * multiplier + (sources.ghost.maxHp || 0);
      } else if (power === 'atk') {
        const multiplier = 2;
        breakdown.base = (sources.base.str || 0) * multiplier + (sources.base.atk || 0);
        breakdown.item = (sources.item.str || 0) * multiplier + (sources.item.atk || 0);
        breakdown.bonus = (sources.bonus.str || 0) * multiplier + (sources.bonus.atk || 0);
        breakdown.trait = (sources.trait.str || 0) * multiplier + (sources.trait.atk || 0);
        breakdown.skill = (sources.skill.str || 0) * multiplier + (sources.skill.atk || 0);
        breakdown.title = (sources.title.str || 0) * multiplier + (sources.title.atk || 0);
        breakdown.tattoo = (sources.tattoo.str || 0) * multiplier + (sources.tattoo.atk || 0);
        breakdown.ghost = (sources.ghost.str || 0) * multiplier + (sources.ghost.atk || 0);
      } else if (power === 'critical') {
        breakdown.base = Number((Math.floor((sources.base.int || 0) / 2) + (sources.base.critical || 0)).toFixed(2));
        breakdown.item = Number((Math.floor((sources.item.int || 0) / 2) + (sources.item.critical || 0)).toFixed(2));
        breakdown.bonus = Number((Math.floor((sources.bonus.int || 0) / 2) + (sources.bonus.critical || 0)).toFixed(2));
        breakdown.trait = Number((Math.floor((sources.trait.int || 0) / 2) + (sources.trait.critical || 0)).toFixed(2));
        breakdown.skill = Number((Math.floor((sources.skill.int || 0) / 2) + (sources.skill.critical || 0)).toFixed(2));
        breakdown.title = Number((Math.floor((sources.title.int || 0) / 2) + (sources.title.critical || 0)).toFixed(2));
        breakdown.tattoo = Number((Math.floor((sources.tattoo.int || 0) / 2) + (sources.tattoo.critical || 0)).toFixed(2));
        breakdown.ghost = Number((Math.floor((sources.ghost.int || 0) / 2) + (sources.ghost.critical || 0)).toFixed(2));
      } else if (power === 'evasion') {
        breakdown.base = Number((Math.floor((sources.base.agi || 0) / 2) + (sources.base.evasion || 0)).toFixed(2));
        breakdown.item = Number((Math.floor((sources.item.agi || 0) / 2) + (sources.item.evasion || 0)).toFixed(2));
        breakdown.bonus = Number((Math.floor((sources.bonus.agi || 0) / 2) + (sources.bonus.evasion || 0)).toFixed(2));
        breakdown.trait = Number((Math.floor((sources.trait.agi || 0) / 2) + (sources.trait.evasion || 0)).toFixed(2));
        breakdown.skill = Number((Math.floor((sources.skill.agi || 0) / 2) + (sources.skill.evasion || 0)).toFixed(2));
        breakdown.title = Number((Math.floor((sources.title.agi || 0) / 2) + (sources.title.evasion || 0)).toFixed(2));
        breakdown.tattoo = Number((Math.floor((sources.tattoo.agi || 0) / 2) + (sources.tattoo.evasion || 0)).toFixed(2));
        breakdown.ghost = Number((Math.floor((sources.ghost.agi || 0) / 2) + (sources.ghost.evasion || 0)).toFixed(2));
      } else if (power === 'defense') {
        breakdown.base = sources.base.defense || 0;
        breakdown.item = sources.item.defense || 0;
        breakdown.bonus = sources.bonus.defense || 0;
        breakdown.trait = sources.trait.defense || 0;
        breakdown.skill = sources.skill.defense || 0;
        breakdown.title = sources.title.defense || 0;
        breakdown.tattoo = sources.tattoo.defense || 0;
        breakdown.ghost = sources.ghost.defense || 0;
      } else if (power === 'criticalReduction') {
        breakdown.base = Number((Math.floor(sources.base.luck || 0) + Math.floor((sources.base.defense || 0) / 20)).toFixed(2));
        breakdown.item = Number((Math.floor(sources.item.luck || 0) + Math.floor((sources.item.defense || 0) / 20)).toFixed(2));
        breakdown.bonus = Number((Math.floor(sources.bonus.luck || 0) + Math.floor((sources.bonus.defense || 0) / 20)).toFixed(2));
        breakdown.trait = Number((Math.floor(sources.trait.luck || 0) + Math.floor((sources.trait.defense || 0) / 20)).toFixed(2));
        breakdown.skill = Number((Math.floor(sources.skill.luck || 0) + Math.floor((sources.skill.defense || 0) / 20)).toFixed(2));
        breakdown.title = Number((Math.floor(sources.title.luck || 0) + Math.floor((sources.title.defense || 0) / 20)).toFixed(2));
        breakdown.tattoo = Number((Math.floor(sources.tattoo.luck || 0) + Math.floor((sources.tattoo.defense || 0) / 20)).toFixed(2));
        breakdown.ghost = Number((Math.floor(sources.ghost.luck || 0) + Math.floor((sources.ghost.defense || 0) / 20)).toFixed(2));
      } else if (power === 'dropRateBonus') {
        breakdown.base = Number(((sources.base.luck || 0) * 0.01).toFixed(2));
        breakdown.item = Number(((sources.item.luck || 0) * 0.01).toFixed(2));
        breakdown.bonus = Number(((sources.bonus.luck || 0) * 0.01).toFixed(2));
        breakdown.trait = Number(((sources.trait.luck || 0) * 0.01).toFixed(2));
        breakdown.skill = Number(((sources.skill.luck || 0) * 0.01).toFixed(2));
        breakdown.title = Number(((sources.title.luck || 0) * 0.01).toFixed(2));
        breakdown.tattoo = Number(((sources.tattoo.luck || 0) * 0.01).toFixed(2));
        breakdown.ghost = Number(((sources.ghost.luck || 0) * 0.01).toFixed(2));
      } else if (power === 'flee') {
        breakdown.base = Math.floor(((sources.base.agi || 0) + (sources.base.int || 0)) / 4);
        breakdown.item = Math.floor(((sources.item.agi || 0) + (sources.item.int || 0)) / 4);
        breakdown.bonus = Math.floor(((sources.bonus.agi || 0) + (sources.bonus.int || 0)) / 4);
        breakdown.trait = Math.floor(((sources.trait.agi || 0) + (sources.trait.int || 0)) / 4);
        breakdown.skill = Math.floor(((sources.skill.agi || 0) + (sources.skill.int || 0)) / 4);
        breakdown.title = Math.floor(((sources.title.agi || 0) + (sources.title.int || 0)) / 4);
        breakdown.tattoo = Math.floor(((sources.tattoo.agi || 0) + (sources.tattoo.int || 0)) / 4);
        breakdown.ghost = Math.floor(((sources.ghost.agi || 0) + (sources.ghost.int || 0)) / 4);
      } else if (power === 'damageReduction') {
        breakdown.base = Number((Math.floor((sources.base.defense || 0) / 20)).toFixed(2));
        breakdown.item = Number((Math.floor((sources.item.defense || 0) / 20)).toFixed(2));
        breakdown.bonus = Number((Math.floor((sources.bonus.defense || 0) / 20)).toFixed(2));
        breakdown.trait = Number((Math.floor((sources.trait.defense || 0) / 20)).toFixed(2));
        breakdown.skill = Number((Math.floor((sources.skill.defense || 0) / 20)).toFixed(2));
        breakdown.title = Number((Math.floor((sources.title.defense || 0) / 20)).toFixed(2));
        breakdown.tattoo = Number((Math.floor((sources.tattoo.defense || 0) / 20)).toFixed(2));
        breakdown.ghost = Number((Math.floor((sources.ghost.defense || 0) / 20)).toFixed(2));
      }
      const sumSources = breakdown.base + breakdown.item + breakdown.bonus + breakdown.trait + breakdown.skill + breakdown.title + breakdown.tattoo + breakdown.ghost;
      breakdown.total = sumSources;
      let carryover = 0;
      if (['critical', 'evasion', 'criticalReduction', 'damageReduction', 'dropRateBonus'].includes(power)) {
        let correctTotal = calculatedStats.value[power];
        carryover = correctTotal - sumSources;
        if (carryover > 0) {
          breakdown.carryover = Number(carryover.toFixed(2));
          breakdown.total = correctTotal;
        }
      }
      return breakdown;
    });

    const computeCardStats = (cardSlots = []) => {
      return cardSlots.reduce((sum, slot) => {
        const cs = slot.cardStats || {};
        Object.keys(cs).forEach(k => { sum[k] = (sum[k] || 0) + (cs[k] || 0); });
        return sum;
      }, {});
    };

    const fetchItems = async (charPrivateData) => {
      items.value = [];
      mechanicalItems.value = [];
      equippedItems.value = charPrivateData?.equippedItems || {};
      ghostItems.value = [];
      // Ghost items from characterPrivate (V2 object map)
      if (charPrivateData?.ghostItems && typeof charPrivateData.ghostItems === 'object' && !Array.isArray(charPrivateData.ghostItems)) {
        ghostItems.value = Object.entries(charPrivateData.ghostItems).map(([instanceId, item]) => {
          const tpl = gameItemsData[item.templateId] || {};
          const states = item.states || {};
          return {
            id: instanceId,
            instanceId,
            name: tpl.name || item.templateId,
            ...tpl,
            ...states,
          };
        });
      }
      // Normal equipped items from characterPrivate (V2 object map)
      if (charPrivateData?.equippedItems && typeof charPrivateData.equippedItems === 'object' && !Array.isArray(charPrivateData.equippedItems)) {
        items.value = Object.entries(charPrivateData.equippedItems).map(([instanceId, item]) => {
          const tpl = gameItemsData[item.templateId] || {};
          const states = item.states || {};
          const cardStats = computeCardStats(states.cardSlots);
          return {
            id: instanceId,
            instanceId,
            name: tpl.name || item.templateId,
            ...tpl,
            ...states,
            cardStats,
          };
        });
      }
      // Mechanical items from characterPrivate (V2 object map)
      if (charPrivateData?.mechanicalItems && typeof charPrivateData.mechanicalItems === 'object' && !Array.isArray(charPrivateData.mechanicalItems)) {
        mechanicalItems.value = Object.entries(charPrivateData.mechanicalItems).map(([instanceId, item]) => {
          const tpl = gameItemsData[item.templateId] || {};
          const states = item.states || {};
          const cardStats = computeCardStats(states.cardSlots);
          return {
            id: instanceId,
            instanceId,
            name: tpl.name || item.templateId,
            ...tpl,
            ...states,
            cardStats,
          };
        });
      }
    };

    const playerStore = usePlayerStore();

    const processCharacterData = (data) => {
      if (data) {
        characterData.value = data;
      } else {
        characterData.value = null;
        error.value = 'ไม่พบข้อมูลตัวละคร';
      }
    };

    const processCharacterPrivateData = async (data) => {
      if (data) {
        characterPrivateData.value = {
          ...data,
          itemStats: data.itemStats || {
            str: 0, stamina: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          },
          bonusStats: data.bonusStats || {
            str: 0, stamina: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          },
          stats: data.stats || {
            str: 0, stamina: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          },
          traitStats: data.traitStats || {
            str: 0, stamina: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          },
          skillStats: data.skillStats || {
            str: 0, stamina: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          },
          titleStats: data.titleStats || {
            str: 0, stamina: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          },
          tattooStats: data.tattooStats || {
            str: 0, stamina: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          },
          ghostStats: data.ghostStats || {
            str: 0, stamina: 0, int: 0, agi: 0, luck: 0, maxHp: 0, atk: 0, evasion: 0, critical: 0, defense: 0
          },
          damageTaken: data.damageTaken ?? 0,
          experience: data.experience || 0,
          foodLevel: data.foodLevel || 0,
          happyLevel: data.happyLevel || 0,
          energyLevel: data.energyLevel || 0,
          infectionLevel: data.infectionLevel || 0,
          healCount: data.healCount || 0,
          healCountByCash: data.healCountByCash || 0,
          increaseEnergyByCash: data.increaseEnergyByCash || 0,
          event: data.event || null,
          statPoints: data.statPoints || 0
        };
        await fetchItems(characterPrivateData.value);
      } else {
        characterPrivateData.value = null;
        error.value = 'ไม่พบข้อมูลส่วนตัวของตัวละคร';
      }
    };

    watch(() => playerStore.characterData, (data) => {
      processCharacterData(data);
    }, { immediate: true });

    watch(() => playerStore.characterPrivateData, async (data) => {
      await processCharacterPrivateData(data);
      if (playerStore.characterData && data) loading.value = false;
    }, { immediate: true });

    const subscribeToCharacterData = () => {
      if (!user.value) {
        error.value = 'กรุณาล็อกอินเพื่อดูข้อมูลตัวละคร';
        loading.value = false;
        return;
      }
    };

    watch(() => playerStore.userData, (data) => {
      if (data) {
        isAdmin.value = data.admin === true;
      } else {
        isAdmin.value = false;
      }
    }, { immediate: true });

    const syncItemStats = async () => {
      syncing.value = true;
      try {
        await projectFunctions.httpsCallable('gameActions')({ action: 'syncItemStats' });
      } catch (err) {
        console.error('Sync failed:', err);
      } finally {
        syncing.value = false;
      }
    };

    const goToMenu = () => router.push({ name: 'Home' });

    const openMapsModal = () => {
      toggleModal.value = 'MapsModal';
    };

    const handleExploreMap = (map) => {
      toggleModal.value = '';
    };

    watch(isAllStatsMatching, (newVal) => {
      if (!newVal) {
        syncItemStats();
      }
    });

    onMounted(() => {
      if (!isLoadingAuth.value && user.value) {
        subscribeToCharacterData();
      }
    });

    watch([isLoadingAuth, user], ([newLoadingAuth, newUser]) => {
      if (!newLoadingAuth && newUser) {
        subscribeToCharacterData();
      } else if (!newUser) {
        characterData.value = null;
        characterPrivateData.value = null;
        loading.value = false;
        error.value = 'กรุณาล็อกอินเพื่อดูข้อมูลตัวละคร';
      }
    });

    return {
      nextLevelExp,
      experiencePercentage,
      characterData,
      characterPrivateData,
      totalStats,
      calculatedStats,
      currentHealth,
      loading,
      error,
      goToMenu,
      openMapsModal,
      toggleModal,
      user,
      isLoadingAuth,
      handleExploreMap,
      showStatDetails,
      statBreakdown,
      selectedStat,
      showPowerDetails,
      powerBreakdown,
      selectedPower,
      isAdmin,
      itemMechMismatch,
      isItemStatsMatching,
      isSkillStatsMatching,
      isAllStatsMatching,
      syncing
    };
  }
};
</script>
<style scoped>
.animate-spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
#style-1::-webkit-scrollbar {
  width: 5px;
}
#style-1::-webkit-scrollbar-track {
  background: #374151;
  border-radius: 10px;
}
#style-1::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 10px;
}
#style-1::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}
#style-1 {
  scrollbar-width: thin;
  scrollbar-color: #4b5563 #374151;
}
button:not(:disabled):active {
  transform: scale(0.98);
}
.bg {
  background: url('https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/bg%2Fbedroom.png?alt=media&token=be49930f-f889-474c-baea-5cece2a5b3cd') no-repeat center center fixed,
              linear-gradient(to bottom, rgba(31, 41, 55, 0.8), rgba(0, 0, 0, 0.9));
}
.animate-pulse {
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
</style>
